var constants = require('../constants');
var api = require('../../../utils/api');
var commonActions = require('../../common/actions/common');

var latestScoreActions = (function() {

    var _fetchLatestScoreRequest = function() {
        return {
            type: constants.LATEST_SCORE_FETCH_REQUEST
        };
    }

    var _fetchLatestScoreSuccess = function(data) {
        var latestScore = data.scores[0] || {};

        return {
            type: constants.LATEST_SCORE_FETCH_SUCCESS,
            data: latestScore
        };
    }

    var _fetchLatestScore = function(token) {
        return function(dispatch, getState) {
            token = token || getState().auth.token;
            dispatch(_fetchLatestScoreRequest());
            return api.get('/proxy/v1/scores/latest', token).then(function(data) {
                return dispatch(_fetchLatestScoreSuccess(data));
            }).catch(function(error){
                if(error.response){
                    dispatch(commonActions.setGenericResponseError('', error.response));
                }else{
                    dispatch(commonActions.setGenericError('', error.message));
                }
            });
        };
    }

    return {
        fetchLatestScore: _fetchLatestScore
    }
})();

module.exports = latestScoreActions;



// WEBPACK FOOTER //
// ./src/common/modules/latestScore/actions/latestScore.js